import { render, staticRenderFns } from "./OwlView.vue?vue&type=template&id=33984457&"
import script from "./OwlView.vue?vue&type=script&lang=js&"
export * from "./OwlView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports